module.exports = __webpack_public_path__ + "img/brand_title.404e7229.png";